export default __webpack_public_path__ + "static/media/489.37e26d22.gif";